function _typeof(o) {
    '@babel/helpers - typeof';
    return _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (o) {
        return typeof o;
    } : function (o) {
        return o && 'function' == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? 'symbol' : typeof o;
    }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, 'prototype', { writable: false });
    return Constructor;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, 'string');
    return 'symbol' == _typeof(i) ? i : i + '';
}
function _toPrimitive(t, r) {
    if ('object' != _typeof(t) || !t)
        return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != _typeof(i))
            return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
    }
    return ('string' === r ? String : Number)(t);
}
var Template = function () {
    function Template(options) {
        _classCallCheck(this, Template);
        this.container = options.container;
        this.options = options.options;
        this.index = options.index;
        this.tran = options.tran;
        this.icons = options.icons;
        this.init();
    }
    return _createClass(Template, [
        {
            key: 'init',
            value: function init() {
                this.container.innerHTML = this.tpl(this.options, this.index, this.tran, this.icons);
                this.video = this.container.querySelector('.lineplayer-video-current');
                this.bezel = this.container.querySelector('.lineplayer-bezel-icon');
                this.videoWrap = this.container.querySelector('.lineplayer-video-wrap');
                this.controllerMask = this.container.querySelector('.lineplayer-controller-mask');
                this.mask = this.container.querySelector('.lineplayer-mask');
                this.controller = this.container.querySelector('.lineplayer-controller');
                this.menu = this.container.querySelector('.lineplayer-menu');
                this.notice = this.container.querySelector('.lineplayer-notice');
                this.title = this.container.querySelector('.lineplayer-title');
                this.play = this.container.querySelector('.lineplayer-play');
                this.prev = this.container.querySelector('.lineplayer-prev');
                this.next = this.container.querySelector('.lineplayer-next');
                this.volume = this.container.querySelector('.lineplayer-volume');
                this.liveBadge = this.container.querySelector('.lineplayer-live-badge');
                this.quality = this.container.querySelector('.lineplayer-quality');
                this.screenshot = this.container.querySelector('.lineplayer-screenshot');
                this.fullScreen = this.container.querySelector('.lineplayer-full');
            }
        },
        {
            key: 'tpl',
            value: function tpl(options, index, tran) {
                return '<div class="lineplayer-mask"></div><div class="lineplayer-video-wrap">'.concat(this.tplVideo(true, options.screenshot), '').concat(options.title ? '<div class="lineplayer-title">'.concat(options.title, '</div>') : '', '').concat(options.logo ? '<div class="lineplayer-logo"><img src="'.concat(options.logo, '"></div>') : '', '<div class="lineplayer-bezel"><span class="lineplayer-bezel-icon"></span><span class="lineplayer-danloading">').concat(tran('LinePlayer is loading'), '</span><span class="lineplayer-loading-icon"><svg height="100%" version="1.1" viewBox="0 0 22 22" width="100%"><svg x="7" y="1"><circle class="lineplayer-loading-dot lineplayer-loading-dot-0" cx="4" cy="4" r="2"></circle></svg><svg x="11" y="3"><circle class="lineplayer-loading-dot lineplayer-loading-dot-1" cx="4" cy="4" r="2"></circle></svg><svg x="13" y="7"><circle class="lineplayer-loading-dot lineplayer-loading-dot-2" cx="4" cy="4" r="2"></circle></svg><svg x="11" y="11"><circle class="lineplayer-loading-dot lineplayer-loading-dot-3" cx="4" cy="4" r="2"></circle></svg><svg x="7" y="13"><circle class="lineplayer-loading-dot lineplayer-loading-dot-4" cx="4" cy="4" r="2"></circle></svg><svg x="3" y="11"><circle class="lineplayer-loading-dot lineplayer-loading-dot-5" cx="4" cy="4" r="2"></circle></svg><svg x="1" y="7"><circle class="lineplayer-loading-dot lineplayer-loading-dot-6" cx="4" cy="4" r="2"></circle></svg><svg x="3" y="3"><circle class="lineplayer-loading-dot lineplayer-loading-dot-7" cx="4" cy="4" r="2"></circle></svg></svg></span></div></div><div class="lineplayer-controller-mask"></div><div class="lineplayer-controller"><ul class="lineplayer-icons lineplayer-icons-left"><li class="lineplayer-play"></li><li class="lineplayer-prev"></li><li class="lineplayer-next"></li><li class="lineplayer-volume"></li><li class="lineplayer-live"><span class="lineplayer-live-badge"><span class="lineplayer-live-dot" style="background: ').concat(options.theme, ';"></span>').concat(tran('Live'), '</span></li></ul><ul class="lineplayer-icons lineplayer-icons-right"><li class="lineplayer-quality"></li><li class="lineplayer-screenshot"></li><li class="lineplayer-full"></li></ul></div>').concat(this.tplContextmenuList(options.contextmenu), '<div class="lineplayer-notice"></div>');
            }
        },
        {
            key: 'tplContextmenuList',
            value: function tplContextmenuList(contextmenu) {
                var result = '<div class="lineplayer-menu">';
                for (var i = 0; i < contextmenu.length; i++) {
                    result += '<div class="lineplayer-menu-item"><a target="_blank" href="'.concat(contextmenu[i].link, '">').concat(this.tran(contextmenu[i].text), '</a></div>');
                }
                result += '</div>';
                return result;
            }
        },
        {
            key: 'tplButton',
            value: function tplButton(name, icon) {
                var _this = this;
                var disable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                var content = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (content) {
                    return content('tplHint', null);
                };
                var contentPanel = function contentPanel(show) {
                    return show ? content(function (tplFunction, options) {
                        if (tplFunction && {}.toString.call(_this[tplFunction]) === '[object Function]') {
                            return _this[tplFunction](name, icon, options);
                        }
                        return _this.tplHint(name, icon);
                    }) : '';
                };
                return '<button class="lineplayer-icon'.concat(disable ? ' disable' : '', '"><span class="lineplayer-icon-content">').concat(this.icons.get(icon, disable), '</span></button>').concat(contentPanel(!disable));
            }
        },
        {
            key: 'tplCameraPreview',
            value: function tplCameraPreview(name, icon, options) {
                console.log(options);
                var image = options['image'], description = options['description'];
                return '<div class="lineplayer-button-mask"><div class="lineplayer-button-panel lineplayer-button-'.concat(icon, '-panel"><span>').concat(this.tran(name), '</span>').concat(image ? '<img src="'.concat(image, '" alt="').concat(this.tran(name), '"/>') : '', '<span>').concat(description, '</span></div></div>');
            }
        },
        {
            key: 'tplVolume',
            value: function tplVolume() {
                return '<div class="lineplayer-volume-bar-wrap" data-balloon-pos="up"><div class="lineplayer-volume-bar"><div class="lineplayer-volume-bar-inner" style="background: '.concat(this.options.theme, ';"><span class="lineplayer-thumb" style="background: ').concat(this.options.theme, '"></span></div></div></div>');
            }
        },
        {
            key: 'tplQuality',
            value: function tplQuality(name, icon, options) {
                var list = options['list'];
                var quality_list = '<div class="lineplayer-button-panel">';
                for (var i = 0; i < list.length; i++) {
                    quality_list += '<div class="lineplayer-quality-item" data-index="'.concat(i, '">').concat(list[i].name, '</div>');
                }
                quality_list += '</div>';
                return '<div class="lineplayer-button-mask">'.concat(quality_list, '</div>');
            }
        },
        {
            key: 'tplHint',
            value: function tplHint(name, icon) {
                return '<div class="lineplayer-button-mask"><div class="lineplayer-button-panel lineplayer-button-'.concat(icon, '-panel"><span>').concat(this.tran(name), '</span></div></div>');
            }
        },
        {
            key: 'tplVideo',
            value: function tplVideo(current, screenshot) {
                return '<video class="lineplayer-video '.concat(current ? 'lineplayer-video-current"' : '', '" webkit-playsinline playsinline ').concat(screenshot ? 'crossorigin="anonymous"' : '', '></video>');
            }
        }
    ]);
}();
module.exports = Template;